module.exports = __webpack_public_path__ + "static/media/silver.a25a9f9b.png";